import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from '../components/Toast';
import { isSessionExpired } from '../utils/sessionExpiredEvent';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = 'success') => {
    if (isSessionExpired()) return;
    setToast({ message, type });
  }, []);

  const hideToast = () => setToast(null);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {/* Toast global, toujours monté */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
